import * as React from 'react';
import type { SVGProps } from 'react';
const SvgZaloIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1rem"
    height="1rem"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#zalo-icon_svg__a)">
      <g clipPath="url(#zalo-icon_svg__b)">
        <path
          fill="#0068FF"
          fillRule="evenodd"
          d="M10.936.08h2.12c2.912 0 4.613.427 6.124 1.237a8.4 8.4 0 0 1 3.503 3.503c.81 1.511 1.238 3.213 1.238 6.124v2.111c0 2.912-.428 4.614-1.238 6.124a8.4 8.4 0 0 1-3.503 3.504c-1.51.81-3.212 1.237-6.124 1.237h-2.111c-2.912 0-4.614-.427-6.124-1.237a8.4 8.4 0 0 1-3.503-3.504C.508 17.67.08 15.967.08 13.056v-2.112c0-2.911.428-4.613 1.238-6.124A8.4 8.4 0 0 1 4.82 1.317C6.322.507 8.033.08 10.936.08"
          clipRule="evenodd"
        />
        <path
          fill="#001A33"
          fillRule="evenodd"
          d="M23.92 12.707v.349c0 2.912-.428 4.613-1.237 6.124a8.4 8.4 0 0 1-3.504 3.503c-1.51.81-3.212 1.238-6.124 1.238h-2.11c-2.383 0-3.956-.287-5.276-.835l-2.177-2.241z"
          clipRule="evenodd"
          opacity={0.12}
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M3.6 20.923c1.115.123 2.509-.195 3.498-.675 4.298 2.375 11.017 2.262 15.084-.34q.237-.357.442-.739c.813-1.516 1.242-3.223 1.242-6.146v-2.119c0-2.922-.43-4.63-1.242-6.146a8.4 8.4 0 0 0-3.516-3.516C17.592.429 15.884 0 12.96 0h-2.127C8.344 0 6.729.313 5.37.911a8 8 0 0 0-.218.203C1.17 4.954.867 13.277 4.245 17.798l.012.02c.52.767.018 2.11-.767 2.895-.128.118-.082.192.11.21"
          clipRule="evenodd"
        />
        <path
          fill="#0068FF"
          d="M9.87 8.16H5.202v1H8.44l-3.194 3.96c-.1.145-.173.281-.173.59v.255h4.404c.219 0 .4-.182.4-.4v-.537H6.477l3.002-3.767.164-.2.018-.028c.173-.254.21-.473.21-.737zM15.811 13.965h.665V8.16h-1.001v5.469c0 .182.145.336.336.336M12.39 9.452a2.276 2.276 0 1 0 2.275 2.275 2.264 2.264 0 0 0-2.275-2.275m0 3.613a1.34 1.34 0 0 1-1.338-1.338c0-.737.601-1.338 1.338-1.338s1.338.601 1.338 1.338-.592 1.338-1.338 1.338M19.434 9.416a2.295 2.295 0 0 0-2.293 2.293 2.295 2.295 0 0 0 2.293 2.293 2.295 2.295 0 0 0 2.293-2.293 2.295 2.295 0 0 0-2.293-2.293m0 3.649c-.747 0-1.347-.6-1.347-1.347 0-.746.6-1.347 1.347-1.347.746 0 1.346.6 1.346 1.347 0 .746-.6 1.347-1.346 1.347"
        />
        <path
          fill="#0068FF"
          d="M14.139 13.965h.537V9.58h-.938v3.995c0 .21.182.391.4.391"
        />
      </g>
    </g>
    <defs>
      <clipPath id="zalo-icon_svg__a">
        <rect width={24} height={24} fill="#fff" rx={4} />
      </clipPath>
      <clipPath id="zalo-icon_svg__b">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgZaloIcon;
